export default __webpack_public_path__ + "static/media/phases_clean_to_close.a43794df.webp";